module.exports = __webpack_public_path__ + "c3e72e49b27c463c131b894435f73fde.mp4";